import type { FC } from 'react';
import * as Chakra from '@chakra-ui/react';
import { QFlex } from '../../../QLayouts';
import { QText } from '../../../QAtoms';
import { useLibraryTranslation } from '../../../i18n';

export type QEmptyFilteredTableProps = { colSpan: number };

export const QEmptyFilteredTable: FC<QEmptyFilteredTableProps> = ({
  colSpan,
}) => {
  const { t } = useLibraryTranslation();
  return (
    <Chakra.Tr>
      <Chakra.Td colSpan={colSpan}>
        <QFlex justifyContent="center">
          <QText fontSize="sm">{t('table.emptyFiltered')}</QText>
        </QFlex>
      </Chakra.Td>
    </Chakra.Tr>
  );
};
